import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteNumber: {
        id: 'ml.quoteandbind.customcomponent.quoteinfo.QuoteId',
        defaultMessage: 'Quote #: '
    }, 
    yourInsuranceQuote:{
        id: 'ml.quoteandbind.customcomponent.quoteinfo.yourInsuranceQuote',
        defaultMessage: 'Your {coverageType} insurance quote'
    },
    mlHeaderForLLCandLLH: {
        id: 'ml.quoteandbind.customcomponent.quoteinfo.Validate information for home',
        defaultMessage: 'Validate information for Landlord'
    }
});
